import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import type { IncomingMessage } from 'http';

import { AddToBasketModal } from './featureFlags';

export const getFeatureFlagsWithMatchers = (req: IncomingMessage) => {
  return getFeatureFlags(req, {
    collapseFlagNames: [
      {
        newName: AddToBasketModal.NAME,
        oldNameMatcher: /^add_to_basket_modal/m,
      },
    ],
  });
};
